import React from "react";
import Navigation from "./Navigation";
import s from "./style.module.scss";
import AccountInfo from "entities/Account/AccountInfo";
import AccountBalance from "entities/Account/AccountBalance";
import Button from "shared/ui/Button";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { AccountStatus } from "entities/Account/AccountStatus";

const AccountContent: React.FC = () => {
  return (
    <section className={s.content}>
      <div className={s.row}>
        <AccountInfo />
        <AccountBalance />
      </div>

      <AccountStatus />

      <Navigation />

      <Button className={s.button} href={ROUTES_PATH.HOME}>
        На главную
      </Button>
    </section>
  );
};

export default AccountContent;
